import { APIConfig } from "../../config/apiConfig";
import moment from "moment";

const formatData = (data) => {
  return data.map((cost) => ({
    _id: cost._id,
    noOfStaff: cost.noOfStaff,
    totalStaffSalaries: cost.totalStaffSalaries,
    split: cost.split,
    month: moment(cost.month).format("MMMM-yyyy"),
    date: moment(cost.date).format("MM/DD/yyyy"),
    dateAdded: moment(cost.createdAt).format("MM/DD/yyyy"),
    createdBy: cost.agentDetails.first_name + " " + cost.agentDetails.last_name,
  }));
};

const state = () => ({
  staffSalaryCosts: [],
  costsToBeUpdated: {},
  error: null,
});

const getters = {
  getCostsToBeUpdated: (state) => state.costsToBeUpdated,
};

const mutations = {
  populateStaffSalaryCosts(state, staffSalaryCosts) {
    state.staffSalaryCosts = staffSalaryCosts;
  },

  setCostsToBeUpdated(state, costs) {
    state.costsToBeUpdated = costs;
  },
};

const actions = {
  findCostToBeUpdated({ commit, state }, costId) {
    let costs = state.staffSalaryCosts.find((cost) => cost._id === costId);
    commit("setCostsToBeUpdated", costs);
  },

  async fetchStaffSalaryCosts({ commit }, params) {
    const { page, limit } = params;
    try {
      const { data } = await APIConfig.get(
        `/staff-salary/?page=${page}&limit=${limit}`
      );

      const staffSalaryCosts = data?.data ? formatData(data?.data) : [];

      commit("populateStaffSalaryCosts", staffSalaryCosts);

      return {
        count: data?.count,
        cost: staffSalaryCosts,
      };
    } catch (error) {
      console.log(error);
    }
  },

  async addNewCosts(_, payload) {
    try {
      const { data } = await APIConfig.post(`/staff-salary`, payload);

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async filterByDatePeriod({ commit }, params) {
    const { page, limit, filterQuery } = params;
    try {
      const { data } = await APIConfig.get(
        `/staff-salary/date-range?page=${page}&limit=${limit}&${filterQuery}`
      );

      if (Object.keys(data).length > 0) {
        const staffSalaryCosts = formatData(data?.data);

        commit("populateStaffSalaryCosts", staffSalaryCosts);

        return {
          count: data?.count,
          cost: staffSalaryCosts,
        };
      } else {
        return {
          count: 0,
          cost: [],
        };
      }
    } catch (error) {
      console.log(error);
    }
  },

  async createTarget(_, payload) {
    try {
      const { data } = await APIConfig.post(`/staff-salary/target`, payload);

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async updateCosts(_, payload) {
    try {
      const { data } = await APIConfig.patch(
        `/staff-salary/${payload.id}`,
        payload
      );

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async deleteCosts(_, id) {
    try {
      const { data } = await APIConfig.delete(`/staff-salary/${id}`);

      return data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
